<loader-overlay-component [show]="isloading"></loader-overlay-component>
<div class="dmv-landing-section inner-home">
  <div class="container">
    <div class="row no-margin">

       <div class="col-6 col-sm-2 mt-4 position-absolute" style="z-index:1">
          <a >
                        <button class="btn btn-primary btn-back top-back-button"
                        
                        (click)="goBack()"><i class="fa fa-chevron-left text-left" ></i> Back</button>
                    </a>  
        </div>
  
        
        <div class="col-12 col-sm-8 mt-4"  *ngIf="dmvStoreService.routeFrom?.from === 'add-another'">
          <div id="searchResu"> </div>
          <p id="addthereco">  </p>
        </div>
  
  
        <div class="col-6 col-sm-2 icon-cart mt-4"  *ngIf="dmvStoreService.routeFrom?.from === 'add-another'">
          <dmv-shoping-cart [registrationsInCart]="dmvStoreService?.registrationsInCart?.dmvRegistrations"></dmv-shoping-cart>
        </div>


     <div class="col-12 col-sm-12 col-md-12 text-center m-auto">
        <div class="mt-5 mb-4 orange-logo">
          <img src="{{globalService.externalResourcesUrl}}{{(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.agencySealFileName}}" class="img-fluid">
        </div>
        </div>

<div style="width:100%"></div>
        <div class="col-12 col-sm-8 col-md-8 text-center m-auto searchContainer">
        <div class="taxCollectorName">{{(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.taxCollectorName}}</div>
        <div class="countyName">{{(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.name}} Tax Collector</div>

        <div id="findyourre">Find your DMV registrations</div>
        <div class="mgnBt20">
        <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
            {{errorMessage}}
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="norecordFound && searchCriteria !== 'SEARCH_BY_PROFILE'" >
          <span class="pl-2" [innerHTML]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.searchNoMatchText"></span>
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="norecordFound && searchCriteria === 'SEARCH_BY_PROFILE'">
          None of the registration(s) in your profile is available for renewal at this time.
        </div>
        </div>
        <form autocomplete="off" class="text-left mb-5" [formGroup]="searchRegistrationForm">
       <div class="checkbox-container " *ngIf="!globalService.getQrCall()" [style.display]="(showPrivacy?'':'none')">
       
              <label>I have read and accepted this <span (click)="openPrivacy()" class="textLink">privacy statement</span>.
                <input type="checkbox"  formControlName="privacy" (change)="privacyClicked()" >
                <span class="checkmark"
                [ngStyle]="f?.privacy?.value?{'background-color':(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor} : {'background-color': 'transparent'}"
                  [style.border-color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor"></span>   
                </label>
            
           
              <div class="alert alert-danger" style="margin-left: -25px;" role="alert" *ngIf="isPrivacy && !f?.privacy?.value">
                Please review and accept the  privacy statement. 
            </div>
      </div>


      <div class="col-12 col-sm-8 col-md-9 select-wrapper-1 searchPage m-auto" [attr.disabled]="f?.privacy?.value ? null : true">
          <select #searchSelectInput 
          [attr.disabled]="f?.privacy?.value ? null : true"
          [ngClass]="{'mdb-select': globalService.browserDetails.isDesktop}" (change)="updateregisteredType(); updateSearchFields($event.target.value)">
            <option value="NO_SEARCH">Search by..</option>
            <option value="SEARCH_BY_PROFILE" *ngIf="userStoreService?.getUserProfile()?.megUserGUID  && hasRegistrationInProfile  && (globalService.cartNature === 'TBD' || globalService.cartNature === 'search')">Search My Profile</option>

            <ng-container  *ngFor="let searchMethod of dmvStoreService.agencyConfig?.agencyDmvConfig?.searchMethods"    >
              <option  value="{{searchMethod.methodID}}"  *ngIf="(
                (searchMethod.methodID  === 1 || searchMethod.methodID  ===2) && 
                (globalService.cartNature === 'TBD' || globalService.cartNature === 'search')
                ) || 
                ( searchMethod.methodID  === 9 && (dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.allowManualRegistration && (globalService.cartNature === 'TBD' || (globalService.cartNature === 'manual' &&  dmvStoreService?.registrationsInCart?.dmvRegistrationsManual?.length>0))) || (searchMethod.methodID  === 10 &&  (globalService.cartNature === 'TBD' || (globalService.cartNature === 'manual' && dmvStoreService?.registrationsInCart?.dmvRegistrationsDuplicate?.length>0)))"
              >{{searchMethod.name}}</option>
            </ng-container>
            <!-- <option *ngFor="let searchMethod of dmvStoreService.agencyConfig?.agencyDmvConfig?.searchMethods" 
            value="{{searchMethod.methodID}}" >{{searchMethod.name}}</option> -->

            <!-- <option value="SEARCH_BY_PIN" *ngIf="(globalService.cartNature === 'TBD' || globalService.cartNature === 'search')">Search by Pin</option>
            <option value="SEARCH_BY_LICENSE_PLATE" *ngIf="(globalService.cartNature === 'TBD' || globalService.cartNature === 'search')">Search by License Plate</option>
            <option *ngIf="((dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.allowManualRegistration) && (globalService.cartNature === 'TBD' || globalService.cartNature === 'manual')" value="MANUAL_ENTRY">Manual Entry</option> -->
            
          </select>
        </div>
       
        
           <div class="checkbox-container" *ngIf="dmvStoreService.agencyConfig?.agencyDmvConfig?.licensePlateSearchOption !== 2 &&  !( searchCriteria === '2' && dmvStoreService.agencyConfig?.agencyDmvConfig?.pinSearchOption !== 1) && (searchCriteria !== 'NO_SEARCH' &&  searchCriteria !== 'SEARCH_BY_PROFILE')">
                <label>{{dmvStoreService.agencyConfig?.agencyDmvConfig?.businessVehicleHintText}}
                    <input type="checkbox" [checked]="registeredType"  (change)="changeRegisteredType($event)">
                    <span class="checkmark"
                    [ngStyle]="registeredType?{'background-color':(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor} : {'background-color': 'transparent'}"
                      [style.border-color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor"></span>   
                  </label> 
          </div>
          <div class="col-12 col-sm-12" *ngIf="dmvStoreService.agencyConfig?.agencyDmvConfig?.licensePlateSearchOption === 2 && (searchCriteria !== 'NO_SEARCH' &&  searchCriteria !== '2' &&  searchCriteria !== 'SEARCH_BY_PROFILE')">
            <div class="row pb-4 infoWarningBox" #infoWarningBox>
              <div class="pl15 text-center">
                <!-- <img src="{{globalService.staticResourceURL}}assets/images/Icon-info.svg" class="img-fluid"> -->
                 
                <i class="customIcon icon-info-payment infoWarningBoxIcon"><svg-image [color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor" name="Icon-icon-info-payment"></svg-image></i> 
              </div>
              <div class="col-10 col-md-11" [innerHTML]="dmvStoreService.agencyConfig?.agencyDmvConfig?.licensePlateSearchInfoText">
               
              </div>
            </div>
          </div>
          <div class="row no-margin form-group">
            <div class="col-12 col-sm-6 mb-2" *ngIf="searchCriteria == '2' " [ngClass]="{ 'offset-sm-3': dmvStoreService.agencyConfig?.agencyDmvConfig?.pinSearchOption === 4 }">
              <label for="labelPin" class="lblPin">{{dmvStoreService.agencyConfig?.agencyDmvConfig?.pinSearchLabel}}</label>
              <input #pin (blur)="globalService.trimValue(f.pin)" type="text" formControlName="pin" class="form-control" placeholder="xxxxxxx"
              [maxlength]="pinMaxlength"   
              [ngClass]="{ 'is-invalid': submitted && f.pin.errors }" >
              <div *ngIf="submitted && f.pin.errors" class="invalid-feedback">
                <div *ngIf="f.pin.errors">Please enter {{dmvStoreService.agencyConfig?.agencyDmvConfig?.pinSearchLabel}}, which must be numeric</div>
              </div>
            </div>
            <div class="col-12 col-sm-6 mb-2" *ngIf="searchCriteria == '1' ">
              <label  for="exampleInputPin" class="lblPin">{{dmvStoreService.agencyConfig?.agencyDmvConfig?.licensePlateSearchLabel}}</label>
              <input #licensePlate (blur)="globalService.trimValue(f.licensePlate)" type="text" formControlName="licensePlate" class="form-control" placeholder="xxxxxxx"
              maxlength="15"  
              [ngClass]="{ 'is-invalid': submitted && f.licensePlate.errors }">
              <div *ngIf="submitted && f.licensePlate.errors" class="invalid-feedback">
                <div *ngIf="f.licensePlate.errors?.required">Please enter {{dmvStoreService.agencyConfig?.agencyDmvConfig?.licensePlateSearchLabel}}</div>
                <div *ngIf="f.licensePlate.errors?.pattern">No symbols allowed except space and hyphen</div>
              </div>
            </div>
           
              <div class="col-12 col-sm-6" *ngIf="(searchCriteria == '1' || searchCriteria == '2' ) && !registeredType && !(dmvStoreService.agencyConfig?.agencyDmvConfig?.pinSearchOption === 4 && searchCriteria !== '1')" >
              <label for="labelDateOfBirth" class="lblPin">DATE OF BIRTH (mm/dd/yyyy)</label>
              
                <input #dateOfBirth [textMask]="{mask: mask}" type="text" formControlName="dateOfBirth" class="form-control" placeholder="mm/dd/yyyy"
                  data-date-format="mm/dd/yyyy" id="dateOfBirth"
                  [ngClass]="{ 'is-invalid': submitted && f.dateOfBirth.errors }">
              
              <div *ngIf="submitted && f.dateOfBirth.errors" class="invalid-feedback">
                <div *ngIf="f.dateOfBirth.errors.required">Please enter date of birth</div>
                <div *ngIf="f?.dateOfBirth?.errors?.invalid">Invalid date of birth</div>
                <div *ngIf="f.dateOfBirth.errors.pattern">Invalid date; use mm/dd/yyyy format including "/"s and 4-digit year</div>
              </div>
              </div>
               <div class="col-12 col-sm-6" *ngIf="(searchCriteria == '1' || searchCriteria == '2' ) && registeredType">
              <label for="expirationDate" class="lblPin">EXPIRATION DATE (mm/dd/yyyy)</label>
              
                <input #expirationDate  [textMask]="{mask: mask}"  type="text" formControlName="expirationDate" class="form-control" placeholder="mm/dd/yyyy"
                  data-date-format="mm/dd/yyyy" id="expirationDate"
                  [ngClass]="{ 'is-invalid': submitted && f?.expirationDate?.errors }">
              
              <div *ngIf="submitted && f?.expirationDate?.errors" class="invalid-feedback">
                <div *ngIf="f?.expirationDate?.errors?.required">Please enter expiration date</div>
                <div *ngIf="f?.expirationDate?.errors?.invalid">Invalid expiration date</div>
                 <div *ngIf="f.expirationDate.errors.pattern">Invalid date; use mm/dd/yyyy format including "/"s and 4-digit year</div>
              </div>
              </div>

            
          </div>

          <!--div class="row no-margin" *ngIf="searchCriteria == 'MANUAL_ENTRY' ">
            <div class="col-12 col-sm-6 mb-2">
              <label for="exampleInputPin" class="lblPin">Pin or decal</label>
              <input type="text" class="form-control" placeholder="Enter PIN or decal">
            </div>

            <div class="col-12 col-sm-6">
              <label for="exampleInputDOB" class="lblPin">Date of Birth</label>
              <div class="input-group date">
                <input type="text" class="form-control" placeholder="00/00/0000" data-date-format="dd/mm/yyyy"
                  id="datepicker">
              </div>
            </div>

          </div-->
        </form>
        <a *ngIf="searchCriteria != 'NO_SEARCH' ">
          <button class="btn btn-primary btn-commonbtn m-auto " (click)="searchRegistrations()">Search Records</button>
        </a>
      </div>
       <div style="width:100%"></div>
      <div style="width:100%" id="NoSearchCriteria" class="row no-margin" *ngIf="searchCriteria == 'NO_SEARCH' ">
        <div class="col-12 col-sm-6 mb-4">
          <div class="row">
            <div class="col-2 no-padding text-center">
               <i class="customIcon icon-truck">
              <svg-image [color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor" name="Icon-truck"></svg-image>
               </i>
            </div>
            <div class="col-10 no-padding">
              Commercial trucks weighing 26,000 pounds or more cannot be processed online.
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6">
          <div class="row">
            <div class="col-2 no-padding text-center">
              <!-- <img src="{{globalService.staticResourceURL}}assets/images/Icon-info.svg" class="img-fluid"> -->
               
              <i class="customIcon icon-info-payment"><svg-image [color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor" name="Icon-icon-info-payment"></svg-image></i> 
            </div>
            <div class="col-10 no-padding">
              IMPORTANT: Insurance information may be needed to complete your registration.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="m-auto text-center"  *ngIf="dmvStoreService.routeFrom?.from === 'add-another'">
                  <a >
                        <button class="btn btn-primary btn-back" (click)="goBack()"><i class="fa fa-chevron-left text-left"></i> Back</button>
                    </a>  
                     
      </div>
  </div>
</div>
<dmv-privacy (closePopup)="closePrivacy()" [privacyPolicy]="dmvStoreService?.agencyConfig?.agencyDmvConfig?.privacyStatement" *ngIf="isPrivacyOpen"></dmv-privacy>